import { all } from "redux-saga/effects";
import categoryWatcher from "./category";
import loginWatcher from "./login";
import speakerWatcher from "./speaker";
import staffWatcher from "./staff";
import usersWatcher from "./user";
import eventWatcher from "./event";
import cmsWatcher from "./cms";
import newsWatcher from "./news";
import adminWatcher from "./admin";

export default function* rootSaga() {
  yield all([
    categoryWatcher(),
    loginWatcher(),
    speakerWatcher(),
    staffWatcher(),
    usersWatcher(),
    eventWatcher(),
    cmsWatcher(),
    newsWatcher(),
    adminWatcher(),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/index.js